// extracted by extract-css-chunks-webpack-plugin
module.exports = {"find-store-label":"yFzp-","search-store-button":"kE3jI"};